import type { SupportAction } from '../../api/help-content';
import { isSupportAction } from './help-content';
import { helpStudioTarget, saveHelpStudioTarget } from './help-studio-entry';
import { openStudioTarget } from '../studio/studio-navigation';

const routes: Record<string, string> = {
  voices: '#clone',
  subscription: '#balance',
  studio: '#studio',
  templates: '#studio',
  tts: '#tts',
  voice: '#studio',
  vmsg: '#studio',
  stt: '#studio',
  text: '#studio.text',
  clone: '#clone',
  script: '#projects',
  projects: '#projects',
  circle: '#studio.circle',
  avatar: '#studio.avatar',
  photo: '#studio.photo',
  video: '#studio.video',
  reels: '#studio.reels',
  cover: '#studio.cover',
  dance: '#studio.dance',
  shoot: '#studio.shoot',
  pshoot: '#studio.pshoot',
  post: '#studio.post',
  collage: '#studio.collage',
  infog: '#studio.infog',
  mcard: '#studio.mcard',
  market: '#studio.market',
  profile: '#profile',
  settings: '#settings',
  history: '#history',
  balance: '#balance',
  rewards: '#rewards',
  partner: '#partner',
  sid: '#profile.pusid',
  payout: '#partner',
  qr: '#partner',
  packs: '#balance',
  promo: '#balance',
  gift: '#balance',
  chat: '#profile',
  help: '#help',
};
export function helpRoute(open: unknown): string | null {
  if (typeof open === 'string') return Object.hasOwn(routes, open) ? routes[open] : Object.values(routes).includes(open) ? open : null;
  if (!isSupportAction(open)) return null;
  if (open.kind === 'collection') return ['all', 'scenes', 'market'].includes(open.id) ? '#studio' : null;
  if (open.kind === 'tool' && helpStudioTarget(open.id) && open.id !== 'script') return '#studio';
  return Object.hasOwn(routes, open.id) ? routes[open.id] : null;
}
export function navigateHelp(open: string | SupportAction) {
  const route = helpRoute(open);
  if (!route) return false;
  const id = typeof open === 'string' ? open : open.id;
  if (typeof open !== 'string' && open.kind === 'collection') openStudioTarget(id === 'all' ? { view: 'catalog' } : { collection: id });
  if (id === 'templates') openStudioTarget({ view: 'catalog' });
  if (typeof open !== 'string' && open.kind === 'tool') {
    const target = helpStudioTarget(id);
    if (target && id !== 'script')
      try {
        saveHelpStudioTarget(target);
      } catch {
        return false;
      }
  }
  /* вкладка «Партнёрства» и лист «Баланса» — фокусом шаблонного раздела до его открытия */
  const page = (name: 'BotPartner' | 'BotBalance') => (window as unknown as Record<string, { focus?: (o: object) => void } | undefined>)[name];
  if (id === 'payout' || id === 'qr') page('BotPartner')?.focus?.(id === 'payout' ? { tab: 'out' } : { tab: 'mat', qr: true });
  if (id === 'packs' || id === 'promo' || id === 'gift') page('BotBalance')?.focus?.({ [id]: true });
  window.location.hash = route;
  return true;
}
